import React, { Component } from 'react';

export default class BinaryBackground extends Component {

	constructor(props) {
	  super(props);
		
	  this.state = {
	  	binaryArray: [],
	  }
	}

	componentWillMount() {
		this.createBinaryNumberArray()
	}
	componentDidMount() {
		this.startUpdate()
	}


	render() {

		const opacity = this.props.opacity || 0.15
		const color = this.props.color || 'white'
		const lineHeight = window.innerWidth > 900 ? '25px' : window.innerWidth > 550 ? '20px' : '18px'

		return (
			<p style={{
				color: color, 
				opacity: opacity, 
				wordWrap: 'break-word', 
				wordBreak: 'break-all', 
				userSelect: 'none',
				lineHeight: lineHeight,
				textAlign: 'center'
			}}>{this.state.binaryArray.join('')}</p>
		)
	}


	createBinaryNumberArray() {

		const binaryArray = []
		const length = this.props.length || 6000

		for (var i = 0; i < length; i++) {
			const value = Math.floor(Math.random() * 2)
			binaryArray.push(value)
		}

		this.setState({binaryArray})
	}


	startUpdate() {

		const updateInterval = this.props.updateInterval || 100

		setInterval(() => {
			const randIndexes = this.getRandomIndexes()
			this.updateBinaryNumbers(randIndexes)
		}, updateInterval)
	}


	updateBinaryNumbers(indexes) {

		const binaryArray = this.state.binaryArray

		for (var i = 0; i < indexes.length; i++) {
			const index = indexes[i]
			const currentValue = Number(binaryArray[index])
			binaryArray[index] = (1 - currentValue).toString()
		}

		this.setState({binaryArray: binaryArray})
	}


	getRandomIndexes() {

		let indexes = []
		const binaryLength = this.state.binaryArray.length

		for (var i = 0; i < 500; i++) {
			const index = Math.floor(Math.random() * binaryLength)
			indexes.push(index)
		}

		return indexes
	}
}


// WEBPACK FOOTER //
// ./src/components/BinaryBackground.js